import MaskUtil from "common/util/MaskUtil";
export default function () {
	window.ObserverUtil.observe('modal', () => {
		MaskUtil.initIntlTelMask($('.modal .crm-phone-input'));
	});

	MaskUtil.initIntlTelMask($('.crm-phone-input'));
}